module.exports = __webpack_public_path__ + "images/花筑村全景_07.jpg?v=e504db1c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_07.jpg
 ** module id = 99
 ** module chunks = 1 2
 **/